var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9707 0.93457C19.5497 0.355529 20.4863 0.355734 21.0654 0.93457C21.6444 1.5137 21.6443 2.45015 21.0654 3.0293L9.04199 15.0537L9.04102 15.0527C8.90349 15.1905 8.74039 15.3005 8.56055 15.375C8.38094 15.4493 8.18852 15.4864 7.99414 15.4863V15.4873C7.6154 15.4873 7.23503 15.3425 6.94629 15.0537L0.93457 9.04199C0.355278 8.46298 0.355278 7.5253 0.93457 6.94629C1.51362 6.36742 2.45024 6.36753 3.0293 6.94629L7.99414 11.9111L18.9707 0.93457Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconNew);
export default __webpack_public_path__ + "static/media/check_icon_new.df2b77819b410659177dad0847b14ed2.svg";
export { ForwardRef as ReactComponent };